import React from 'react';
import { GetFlag } from '../../../utils/featureFlag';
import StaticTokenRenewal from './StaticTokenRenewal';
import DynamicTokenRenewal from './DynamicTokenRenewal';

const TokenManager: React.FC = () => {
  const enableDynamicTokenRefresh = GetFlag('enable_dynamic_token_refresh');

  return (
    <>
      {enableDynamicTokenRefresh ? (
        <DynamicTokenRenewal />
      ) : (
        <StaticTokenRenewal />
      )}
    </>
  );
};

export default TokenManager;
